import React, { useState, useEffect } from "react";
import { IoChevronBack } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import AddHeadingSection from "../Components/meetingHeading/AddHeadingSection";
import MeetingsApi from "../Apis/Meetings";
import { toast } from "react-toastify";
import { userID } from "../utils/storage";

const MeetingTitle = () => {
  const navigate = useNavigate();
  const [headings, setHeadings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [updateTrigger, setUpdateTrigger] = useState(false);

  useEffect(() => {
    const fetchMeetingTitles = async () => {
      try {
        setLoading(true);
        const response = await MeetingsApi.getMeetingTitles();
        
        // Transform titles array to match the component's expected format
        const transformedHeadings = response.data.titles.map((title, index) => ({
          id: index + 1,
          name: title
        }));
        
        setHeadings(transformedHeadings);
        setError(null);
      } catch (err) {
        console.error("Error fetching meeting titles:", err);
        setError("Failed to load meeting titles");
        toast.error("Failed to load meeting titles");
      } finally {
        setLoading(false);
      }
    };

    fetchMeetingTitles();
  }, [updateTrigger]);

  const handleAddHeading = async (newHeading) => {
    try {
      await MeetingsApi.addMeetingTitle(userID, newHeading);
      
      toast.success("Meeting heading added successfully");
      setUpdateTrigger(!updateTrigger); // Refresh the list
    } catch (err) {
      console.error("Error adding heading:", err);
      const errorMessage = err.response?.data?.error || "Failed to add meeting heading";
      toast.error(errorMessage);
    }
  };

  const handleUpdateHeading = async (oldTitle, newTitle) => {
    try {
      await MeetingsApi.updateMeetingTitle(userID, oldTitle, newTitle);
      
      toast.success("Meeting heading updated successfully");
      setUpdateTrigger(!updateTrigger); // Refresh the list
    } catch (err) {
      console.error("Error updating heading:", err);
      const errorMessage = err.response?.data?.message || "Failed to update meeting heading";
      toast.error(errorMessage);
    }
  };

  if (loading) {
    return (
      <div className="">
        <div className="flex items-center gap-3 mb-6">
          <button
            onClick={() => navigate("/setup")}
            className="text-gray-600 hover:text-gray-800 transition-colors"
          >
            <IoChevronBack className="text-2xl" />
          </button>
          <h1 className="text-2xl font-semibold text-gray-800">
            Meeting Headings
          </h1>
        </div>
        <div className="flex justify-center items-center h-64">
          <div className="text-gray-500">Loading meeting headings...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="">
      {/* Header with back button */}
      <div className="flex items-center gap-3 mb-6">
        <button
          onClick={() => navigate("/setup")}
          className="text-gray-600 hover:text-gray-800 transition-colors"
        >
          <IoChevronBack className="text-2xl" />
        </button>
        <h1 className="text-2xl font-semibold text-gray-800">
          Meeting Headings
        </h1>
      </div>

      {/* Add Heading Section */}
      <AddHeadingSection
        headings={headings}
        onAdd={handleAddHeading}
        onUpdate={handleUpdateHeading}
        maxHeadings={250}
      />
    </div>
  );
};

export default MeetingTitle;
